module.exports = "https://cdn.realtymogul.com/static/media/icon_bullet_check.bcd0aaaa.svg";